import mixpanel from "web/script/embedded/mixpanel";
import environment from "web/script/modules/environment";

export default {
    init: function () {
        if (
            environment.get("enableMixpanel") &&
            environment.get("mixpanelToken") &&
            environment.get("geoip_country") !== "US"
        ) {
            mixpanel();
        }
    },

    send: function () {},
};
